import { AbstractControl, Validators } from '@angular/forms';

export const leadingWhitespaceValidatorFn = Validators.pattern(/^\S.*$/);

export function ValidateNoLeadingWhitespace(control: AbstractControl) {
  const err = leadingWhitespaceValidatorFn(control);
  return err ? { whitespace: true } : null;
}
